import * as StorageService from "./storage";

export function isAuthenticated() {
  const auth = StorageService.get("auth");
  return auth && auth.accessToken;
}

export function getAuthData() {
  if (isAuthenticated()) {
    return StorageService.get("auth");
  }
  return null;
}

export function createAuthData(data) {
  StorageService.set("auth", data);
}

export function resetAuthData() {
  StorageService.remove("auth");
}
